import { useEffect, useMemo, useState } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/landing/Header";
import { HeroTrust } from "@/components/landing/HeroTrust";
import { ServicesPricing } from "@/components/landing/ServicesPricing";
import { AboutGalleryReviews } from "@/components/landing/AboutGalleryReviews";
import { EstimateFooter } from "@/components/landing/EstimateFooter";
import { content } from "@/data/marvinContent";

const Home = () => {
  const [lang, setLang] = useState(() => localStorage.getItem("marvin-plumbing-language") || "en");
  const t = useMemo(() => content[lang], [lang]);

  useEffect(() => {
    localStorage.setItem("marvin-plumbing-language", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <div data-testid="marvin-plumbing-page" className="min-h-screen overflow-x-hidden">
      <Header t={t} lang={lang} setLang={setLang} />
      <main data-testid="site-main-content">
        <HeroTrust t={t} />
        <ServicesPricing t={t} />
        <AboutGalleryReviews t={t} />
        <EstimateFooter t={t} lang={lang} />
      </main>
      <Toaster richColors position="top-center" />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
